import {
  type ListQueryResponse,
  type TPaginationQueryParams,
} from 'lib/rtkQuery/types';

/** Phân loại thông báo — SPEC mục 6.1 */
export enum NOTIFICATION_CATEGORY {
  PERSONAL = 'PERSONAL',
  COMPANY = 'COMPANY',
}

export type TNotificationCategory = NOTIFICATION_CATEGORY;

/** Thông báo hộp thư của tôi — GET /me/notifications (SPEC mục 4.1) */
export type TNotification = {
  id: string;
  category: TNotificationCategory;
  type: string;
  type_label: string;
  content: string;
  is_read: boolean;
  sender_name: string | null;
  sender_avatar_id: string | null;
  reference_code: string;
  target_url: string | null;
  created_at: string;
};

export type TNotificationListParams = TPaginationQueryParams & {
  category?: TNotificationCategory;
  unread_only?: boolean;
  search?: string;
};

export type TNotificationListResponse = ListQueryResponse<TNotification[]>;

/** Khóa đếm chưa đọc theo phân loại — khớp field BE trả về trong unread-count */
export enum NOTIFICATION_UNREAD_KEY {
  PERSONAL = 'personal',
  GENERAL = 'general',
}

/** GET /me/notifications/unread-count (SPEC mục 4.2) */
export type TNotificationUnreadCount = {
  total: number;
  personal: number;
  general: number;
};

/** POST /me/notifications/mark-all-read (SPEC mục 4.4) */
export type TMarkAllReadPayload = {
  category?: TNotificationCategory;
};
